// import Layout from '@/pages/newLayout';
import Layout from '@/pages/Layout';
import * as constants from '@/common/constants';
export default [
    {
        path: '/workspace',
        component: Layout,
        redirect: 'noredirect',
        name: 'workspace',
        hidenMenuWaterfall: true,
        meta: {
            title: '工作台',
            icon: 'el-icon-s-home'
        },
        children: [
            {
                path: 'needWorkingTask',
                component: () => import('@/pages/workbench/NeedWorkingTask'),
                isShow: false,
                isEntry: true,
                name: 'needWorkingTask',
                id: 'workspace/needWorkingTask',
                remindNum: constants.VUEX_REMIND_NUM_DATA.todoList,
                navNum: constants.VUEX_NAV_NUM_DATA.needWorkingTask,
                meta: {
                    title: '待办任务',
                    icon: 'iconfont icon-other-daibanshixiang bc-custom-menu',
                    color: '#1296db'
                },
                isMenuWaterfall: true
            },
            {
                path: 'attendancAppeal',
                component: () => import('@/pages/workbench/AttendancAppeal'),
                isShow: false,
                isEntry: true,
                name: 'attendancAppeal',
                id: 'workspace/attendancAppeal',
                remindNum: constants.VUEX_REMIND_NUM_DATA.todoList,
                meta: {
                    title: '考勤申诉',
                    icon: 'iconfont icon-other-daibanshixiang bc-custom-menu',
                    color: '#13227a'
                },
                isMenuWaterfall: true
            },
            {
                path: 'documentApprove',
                component: () => import('@/pages/workbench/DocumentApprove'),
                isShow: false,
                isEntry: true,
                name: 'documentApprove',
                id: 'workspace/documentApprove',
                remindNum: constants.VUEX_REMIND_NUM_DATA.todoList,
                meta: {
                    title: '档案审核',
                    icon: 'iconfont icon-other-daibanshixiang bc-custom-menu',
                    color: '#d4237a'
                },
                isMenuWaterfall: true
            },
            {
                path: 'workAssistant',
                component: () => import('@/pages/workbench/WorkAssistant'),
                isShow: false,
                isEntry: true,
                name: 'workAssistant',
                id: 'workspace/workAssistant',
                meta: {
                    title: '工作助手',
                    icon: 'iconfont icon-other-zhushou bc-custom-menu',
                    color: ''
                },
                isMenuWaterfall: true
            },
            {
                path: 'businessAnalyze',
                component: () => import('@/pages/workbench/BusinessAnalyze'),
                isShow: false,
                isEntry: true,
                name: 'businessAnalyze',
                id: 'workspace/businessAnalyze',
                meta: {
                    title: '报   表   BI',
                    icon: 'iconfont icon-other-bi bc-custom-menu',
                    color: '#d4237a'
                },
                isMenuWaterfall: true
            },
            {
                path: 'workbench',
                component: () => import('@/pages/workbench/Workbench'),
                name: 'workbench',
                isEntry: true,
                id: 'workspace/workbench',
                meta: {
                    title: '便捷入口',
                    icon: 'iconfont icon-other-bianjieOA bc-custom-menu',
                    color: '#1afa29'
                },
                isMenuWaterfall: true
            },
            {
                path: 'myApply',
                component: () => import('@/pages/workbench/MyApply'),
                isShow: false,
                isEntry: true,
                remindNum: constants.VUEX_REMIND_NUM_DATA.myApply,
                name: 'myApply',
                id: 'workspace/myApply',
                meta: {
                    title: '我申请的',
                    icon: 'iconfont icon-other-icon bc-custom-menu',
                    color: '#1296db'
                },
                isMenuWaterfall: true
            },
            {
                path: 'myApprove',
                component: () => import('@/pages/workbench/MyApprove'),
                isShow: false,
                isEntry: true,
                remindNum: constants.VUEX_REMIND_NUM_DATA.myApprove,
                navNum: constants.VUEX_NAV_NUM_DATA.needMyApprove,
                name: 'myApprove',
                id: 'workspace/myApprove',
                meta: {
                    title: '我审批的',
                    icon: 'iconfont icon-other-woshenpide bc-custom-menu',
                    color: '#f4ea2a'
                },
                isMenuWaterfall: true
            },
            {
                path: 'myCarbonCopy',
                component: () => import('@/pages/workbench/MyCarbonCopy'),
                isShow: false,
                isEntry: true,
                remindNum: constants.VUEX_REMIND_NUM_DATA.myCarbonCopy,
                name: 'myCarbonCopy',
                id: 'workspace/myCarbonCopy',
                meta: {
                    title: '抄送我的',
                    icon: 'iconfont icon-other-chaosongwode bc-custom-menu',
                    color: '#1296db'
                },
                isMenuWaterfall: true
            },
            {
                path: 'finishedList',
                component: () => import('@/pages/workbench/FinishedList'),
                isShow: false,
                isEntry: true,
                name: 'finishedList',
                id: 'workspace/finishedList',
                meta: {
                    title: '已办事项',
                    icon: 'iconfont icon-other-yibanshixiang bc-custom-menu',
                    color: '#d4237a'
                },
                isMenuWaterfall: true
            },
            {
                path: 'cronjobNotice',
                component: () => import('@/pages/workbench/CronjobNotice'),
                isShow: false,
                isEntry: true,
                remindNum: constants.VUEX_REMIND_NUM_DATA.cronjobNotice,
                name: 'cronjobNotice',
                id: 'workspace/cronjobNotice',
                meta: {
                    title: '定时通知',
                    icon: 'iconfont icon-other-navicon-dsrwpz bc-custom-menu',
                    color: '#13227a'

                },
                isMenuWaterfall: true
            },
            {
                path: 'warningNotice',
                component: () => import('@/pages/workbench/WarningNotice'),
                isShow: false,
                isEntry: true,
                remindNum: constants.VUEX_REMIND_NUM_DATA.warningNotice,
                name: 'warningNotice',
                id: 'workspace/warningNotice',
                meta: {
                    title: '预警提醒',
                    icon: 'iconfont icon-other-yujing bc-custom-menu',
                    color: '#13227a'
                },
                isMenuWaterfall: true
            },
            {
                path: 'messageNotice',
                component: () => import('@/pages/workbench/MessageNotice'),
                isShow: false,
                isEntry: true,
                remindNum: constants.VUEX_REMIND_NUM_DATA.messageNotice,
                name: 'messageNotice',
                id: 'workspace/messageNotice',
                meta: {
                    title: '消息公告',
                    icon: 'iconfont icon-other-gonggao bc-custom-menu',
                    color: '#1afa29'
                },
                isMenuWaterfall: true
            },
            {
                path: 'projectMainLine',
                component: () => import('@/pages/workbench/ProjectMainLine'),
                isShow: false,
                isEntry: true,
                // remindNum:constants.VUEX_REMIND_NUM_DATA.messageNotice,
                name: 'projectMainLine',
                id: 'workspace/projectMainLine',
                meta: {
                    title: '项目主线',
                    icon: 'iconfont icon-other-xiangmuguanli1 bc-custom-menu',
                    color: '#409eff'
                },
                isMenuWaterfall: true
            },
            {
                path: 'appstore',
                component: () => import('@/pages/appstore/AppStore'),
                isShow: false,
                isEntry: false,
                name: 'appstore',
                id: 'appstore',
                meta: {
                    title: '应用商店',
                    icon: 'table',
                    color: ''
                },
                isMenuWaterfall: false
            },
            {
                path: 'appstore/appView/:appId/:flag',
                component: () => import('@/pages/appstore/AppView'),
                isShow: false,
                isEntry: false,
                name: 'appstore/appView/:appId/:flag',
                id: 'appstore/appView/:appId/:flag',
                meta: {
                    title: '应用预览',
                    icon: 'table',
                    color: ''
                },
                isMenuWaterfall: false
            },
            {
                path: 'appstore/modelView/:formId/:appId',
                component: () => import('@/pages/appstore/ModelView'),
                isShow: false,
                isEntry: false,
                name: 'appstore/modelView/:formId/:appId',
                id: 'appstore/modelView/:formId/:appId',
                meta: {
                    title: '预览模型表单',
                    icon: 'table',
                    color: ''
                },
                isMenuWaterfall: false
            },
            {
                path: 'appstore/componentsView/:appId',
                component: () => import('@/pages/customer/CustomerComponents'),
                isShow: false,
                isEntry: false,
                name: 'modelView',
                id: 'appstore/componentsView/:appId',
                meta: {
                    title: '预览组件',
                    icon: 'table',
                    color: ''
                },
                isMenuWaterfall: false
            },
            {
                path: 'appstore/appDataView/:appId',
                component: () => import('@/pages/appstore/AppDataView'),
                isShow: false,
                isEntry: false,
                name: 'modelDataView',
                id: 'appstore/appDataView/:appId',
                meta: {
                    title: '预览表单数据',
                    icon: 'table',
                    color: ''
                },
                isMenuWaterfall: false
            },
            {
                path: 'appstore/appIntroView/:appId/:appName',
                component: () => import('@/pages/appstore/AppIntroView'),
                isShow: false,
                isEntry: false,
                name: 'appstore/appIntroView/:appId/:appName',
                id: 'appstore/appIntroView/:appId/:appName',
                meta: {
                    title: '应用介绍',
                    icon: 'table',
                    color: ''
                },
                isMenuWaterfall: false
            },
            {
                path: 'help',
                component: () => import('@/pages/static/Help'),
                isShow: false,
                isEntry: false,
                name: 'help',
                id: 'help',
                meta: {
                    title: '系统帮助',
                    icon: 'table',
                    color: ''
                },
                isMenuWaterfall: false
            }
        ]
    }
];



// WEBPACK FOOTER //
// ./src/router/modules/route-workbench.js